import { useTranslations } from 'next-intl';
import { useCallback, useState } from 'react';

import { LocationFilterButton } from '@ui/components/features/locationSearch/locationFilterButton';

import { LocationPickerModal } from '../LocationPicker';
import { LocationPickerDrawer } from '../LocationPicker/LocationPickerDrawer';

interface LocationFilterProps {
  isMobile: boolean;
  locationLabel: string;
  isActive?: boolean;
  setLocation: (location: { latitude: number; longitude: number; name: string }) => void;
  onOpenChange?: (open: boolean) => void;
  className?: string;
}

export const LocationFilter = ({
  isMobile,
  locationLabel,
  isActive,
  setLocation,
  onOpenChange,
  className
}: LocationFilterProps) => {
  const t = useTranslations();
  const [isOpen, setIsOpen] = useState(false);

  const updateOpen = (open: boolean) => {
    setIsOpen(open);
    onOpenChange?.(open);
  };

  const handleClose = () => updateOpen(false);

  const handleLocationSelect = useCallback(
    (location: { latitude: number; longitude: number; name: string }) => {
      setLocation(location);
      updateOpen(false);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setLocation]
  );

  return (
    <>
      <LocationFilterButton
        onClick={() => updateOpen(true)}
        locationLabel={locationLabel}
        chooseLocationText={t('SearchPage.chooseLocation')}
        isActive={isActive}
        className={className}
      />

      {!isMobile && (
        <LocationPickerModal
          isOpen={isOpen}
          onClose={handleClose}
          onLocationSelect={handleLocationSelect}
          title={t('SearchPage.chooseLocation')}
        />
      )}

      {isMobile && (
        <LocationPickerDrawer isOpen={isOpen} onClose={handleClose} onLocationSelect={handleLocationSelect} />
      )}
    </>
  );
};
